import { Controller } from "@hotwired/stimulus"

// Manages the lead job upload modal (2 states: upload / thank-you)
export default class extends Controller {
  static targets = ["uploadArea", "thankYou", "submitButton", "form"]
  static values = { modalId: String }

  handleModalOpened(event) {
    if (event.detail?.id !== this.modalIdValue) return
    this.reset()
  }

  filesChanged(event) {
    const { count } = event.detail
    if (count > 0) {
      this.submitButtonTarget.classList.remove('hidden')
    } else {
      this.submitButtonTarget.classList.add('hidden')
    }
  }

  uploading() {
    this.submitButtonTarget.classList.add('hidden')
  }

  uploaded() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.classList.remove('hidden')
    }
  }

  startAnother(event) {
    event.preventDefault()
    this.reset()
    this.element.scrollTo?.({ top: 0, behavior: 'smooth' })
  }

  async submit() {
    const btn = this.submitButtonTarget.querySelector('button, a')
    if (btn) {
      btn.disabled = true
      btn.textContent = 'Submitting...'
    }

    const form = this.formTarget
    const formData = new FormData(form)

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
          'Accept': 'application/json'
        }
      })

      if (response.ok) {
        this.uploadAreaTarget.classList.add('hidden')
        this.thankYouTarget.classList.remove('hidden')
      } else {
        const data = await response.json()
        alert(data.error || 'Something went wrong. Please try again.')
        if (btn) {
          btn.disabled = false
          btn.textContent = 'Submit Files'
        }
      }
    } catch (error) {
      console.error('Lead job submission error:', error)
      alert('Something went wrong. Please try again.')
      if (btn) {
        btn.disabled = false
        btn.textContent = 'Submit Files'
      }
    }
  }

  reset() {
    this.uploadAreaTarget.classList.remove('hidden')
    this.thankYouTarget.classList.add('hidden')
    this.submitButtonTarget.classList.add('hidden')

    const btn = this.submitButtonTarget.querySelector('button, a')
    if (btn) {
      btn.disabled = false
      btn.textContent = 'Submit Files'
    }

    const uploadElement = this.element.querySelector('[data-controller~="active-storage-upload"]')
    if (!uploadElement) return

    const uploadController = this.application.getControllerForElementAndIdentifier(uploadElement, 'active-storage-upload')
    uploadController?.resetState?.()
  }
}
